import API from "../../api/api";
import BidCard from "./bidCard";
import Comments from "./Comments";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import JobReviewCard from "./JobReviewCard";
import JobDetailsCard from "./JobDetailsCard";
import "../../styles/css/Jobs/JobCreation.css";
import JobCreationForm from "./JobCreationForm";
import AcceptedBidderCard from "./AcceptedBidderCard";
import { Container, Row, Col } from "bootstrap-4-react";
import ErrorOutileIcon from "@material-ui/icons/ErrorOutline";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import CircularProgress from "@material-ui/core/CircularProgress";
const userRole = localStorage.getItem("userRole");

class JobCreation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editJob: this.props.match.params.id === "0" ? false : true,
      jobId: this.props.match.params.id,
      jobName: "",
      jobStatus: "",
      cardData: {},
      bidsData: "",
      selectedUser: "",
      bidStartedDate: "",
      userComments: "",
      review: "",
      isAccepting: false,
      isRejecting: false,
      isRejected: false,
      isAccepted: false,

      isPageLoading: true,
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== "0") {
      API.post("job/title/" + this.props.match.params.id)
        .then((res) => {
          const jobDetails = res.data.response;
          // console.log("jobDetails", jobDetails);
          this.setState({
            jobName: jobDetails.job[0].name,
            jobStatus: jobDetails.job[0].job_status,
            bidStartedDate: jobDetails.bids
              ? jobDetails.bids.length &&
                jobDetails.bids[0].created_at.date.split(" ")[0]
              : "",
            cardData: jobDetails.card,
            bidsData: jobDetails.bids,
            review: jobDetails.review,
            selectedUser: jobDetails.bids && jobDetails.bids[0],
            userComments: jobDetails.comments && jobDetails.comments,

            isPageLoading: false,
          });
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
        });
    } else {
      this.setState({
        jobName: "Create a job",
        isPageLoading: false,
      });
    }
  }

  acceptingBid = () => {
    this.setState({ isAccepting: true });
  };

  removingBid = () => {
    this.setState({ isRejecting: true });
  };

  acceptBid = () => {
    this.setState({ isAccepting: false });
    this.showCreationMessage("accepted");
  };

  removeBid = (surveyorId) => {
    this.setState({ isRejecting: false });
    var newBidsData = this.state.bidsData;
    newBidsData.forEach((bid) => {
      if (bid.survey_id === surveyorId) {
        newBidsData.splice(newBidsData.indexOf(bid), 1);
        this.setState({ bidsData: newBidsData }, () =>
          this.showCreationMessage("rejected")
        );
      }
    });
  };

  showCreationMessage = (action) => {
    if (action === "accepted") {
      this.setState({
        isAccepted: true,
        isRejected: false,
      });
    } else {
      this.setState({
        isAccepted: false,
        isRejected: true,
      });
    }
    setTimeout(() => {
      this.setState({
        isAccepted: false,
        isRejected: false,
      });
      action === "accepted" && window.location.reload();
    }, 1000);
  };

  render() {
    const {
      jobStatus,
      isAccepted,
      isRejected,
      isAccepting,
      isRejecting,
      isPageLoading,
      bidsData,
    } = this.state;
    console.log(this.props);
    return (
      <div>
        {isPageLoading ? (
          <div className="preloader">
            <CircularProgress className="preloaderCircle" />
          </div>
        ) : (
          <div className="jobCreationMain">
            <Container className="breadCrubmContainerDashboard">
              <div className="breadCrumb">
                <Link to="/" className="prevLinks">
                  Dashboard
                </Link>
                <span>&nbsp;&gt;&nbsp;</span>

                {userRole === "Admin" && (
                  <span>
                    {" "}
                    <Link to="/all-jobs" className="prevLinks">
                      All Jobs
                    </Link>
                    <span>&nbsp;&gt;&nbsp;</span>
                  </span>
                )}

                <span className="currLink">{this.state.jobName}</span>
              </div>
            </Container>
            <div className="browseMain">
              <Container>
                <Row>
                  <Col col="sm-12 md-12 lg-3">
                    <div>
                      <JobDetailsCard
                        jobId={this.state.jobId}
                        cardData={this.state.cardData}
                        bidStartedDate={this.state.bidStartedDate}
                      />
                    </div>
                    {jobStatus === "Completed" && (
                      <div>
                        <JobReviewCard
                          review={this.state.review}
                          jobId={this.props.match.params.id}
                        />
                      </div>
                    )}
                  </Col>
                  <Col col="sm-12 md-12 lg-9">
                    {this.props.match.params.id !== "0" &&
                      jobStatus !== "Created" &&
                      jobStatus !== "In-progress" &&
                      jobStatus !== "Verify" &&
                      jobStatus !== "Completed" &&
                      bidsData.length > 0 && (
                        <div>
                          <div className="activeUsersDiv">
                            <span>Active Bidders</span>
                            {isAccepting ? (
                              <CircularProgress className="circularColor3" />
                            ) : (
                              isAccepted && (
                                <div className="messageBody userCreationSuccessColor bidActionMsg">
                                  <div className="messageAction">
                                    <ErrorOutileIcon />
                                  </div>
                                  <div className="userCreationSuccess">
                                    Bid has been accepted!
                                  </div>
                                </div>
                              )
                            )}
                            {isRejecting ? (
                              <CircularProgress className="circularColor3" />
                            ) : (
                              isRejected && (
                                <div className="messageBody userCreationSuccessColor bidActionMsg">
                                  <div className="messageAction">
                                    <ErrorOutileIcon />
                                  </div>
                                  <div className="userCreationSuccess">
                                    Bid has been rejected!
                                  </div>
                                </div>
                              )
                            )}
                            <ArrowDropDownIcon />
                          </div>
                          <BidCard
                            bidsData={this.state.bidsData}
                            acceptingBid={this.acceptingBid}
                            removingBid={this.removingBid}
                            acceptBid={this.acceptBid}
                            removeBid={this.removeBid}
                            jobId={this.state.jobId}
                          />
                        </div>
                      )}
                    {(jobStatus === "In-progress" ||
                      jobStatus === "Verify" ||
                      jobStatus === "Completed") && (
                      <div>
                        <div col="sm-12 md-12 lg-9">
                          <div>
                            <div className="activeUsersDiv">
                              <span>Assigned Surveyor</span>
                              <ArrowDropDownIcon />
                            </div>
                            <AcceptedBidderCard
                              selectedUserData={this.state.selectedUser}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {(jobStatus === "In-progress" ||
                      jobStatus === "Verify" ||
                      jobStatus === "Completed") && (
                      //comments
                      <div>
                        <div>
                          <div>
                            <div className="activeUsersDiv">
                              <span>Comments</span>
                              <ArrowDropDownIcon />
                            </div>
                            <Comments
                              jobId={this.props.match.params.id}
                              comments={this.state.userComments}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    <div>
                      <JobCreationForm
                        editJob={this.state.editJob}
                        jobId={this.props.match.params.id}
                      />
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default JobCreation;



// WEBPACK FOOTER //
// ./src/pages/Jobs/JobCreation.js